<span
    class="action-tag cmps-gp-bg-color-ukn-104 cmps-gp-border-color-ukn-100 cmps-gp-color-ukn-101 cmps-cdk-cursor-default cmps-cdk-line-clamp-1"
    >{{ _i18n._11312_NO_ACTIONS_TAG | translate }}</span
>
